/** Cookie names used by proxy route guards. */
export const ACCESS_TOKEN_COOKIE = "nova_access_token"
export const USER_ROLE_COOKIE = "nova_user_role"

/** Locale paths that receive auth cookies (not sent to /api). */
export const AUTH_COOKIE_LOCALE_PATHS = ["/en", "/ar"] as const

/** Paths to clear on logout, including legacy Path=/. */
export const AUTH_COOKIE_CLEAR_PATHS = ["/", "/en", "/ar"] as const

/** @deprecated Use AUTH_COOKIE_CLEAR_PATHS / AUTH_COOKIE_LOCALE_PATHS. */
export const AUTH_COOKIE_PATHS = AUTH_COOKIE_CLEAR_PATHS

export type AuthCookieOptions = {
  httpOnly: true
  secure: boolean
  sameSite: "strict"
  path: string
  maxAge?: number
}

/**
 * Build Set-Cookie options for auth cookies.
 * HttpOnly must be set server-side — document.cookie cannot set it.
 */
export function authCookieOptions(
  path: string,
  maxAge?: number,
  secure = process.env.NODE_ENV === "production"
): AuthCookieOptions {
  const options: AuthCookieOptions = {
    httpOnly: true,
    secure,
    sameSite: "strict",
    path,
  }
  if (maxAge !== undefined) {
    options.maxAge = maxAge
  }
  return options
}

/** Serialize one Set-Cookie header value (one name+path per call). */
export function serializeAuthCookie(
  name: string,
  value: string,
  path: string,
  maxAge: number,
  secure: boolean
): string {
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    `Path=${path}`,
    `Max-Age=${Math.max(0, Math.floor(maxAge))}`,
    "HttpOnly",
    "SameSite=Strict",
  ]
  if (secure) parts.push("Secure")
  if (maxAge <= 0) {
    parts.push("Expires=Thu, 01 Jan 1970 00:00:00 GMT")
  }
  return parts.join("; ")
}
